import { FC } from 'react';
import { Link } from 'react-router-dom';
import { CartSVG, InfoSVG } from '../../components/svgs';
import { BUTTON_CONSTANTS, GUEST_MARKETPLACE_CONSTANTS } from '../../constants/common';
import { ROUTE_PATHS } from '../../constants/routePaths';
import './guestMarketplace.scss';

type Props = {
  cartItemCount: number;
};

const GuestMarketplaceHeader: FC<Props> = ({ cartItemCount }) => {
  const [taglineTitle, taglineDescription] = GUEST_MARKETPLACE_CONSTANTS.HEADER_TAGLINE.split(' - ');

  return (
    <header className="guest-marketplace-header">
      <div className="guest-marketplace-header__brand">
        <img
          className="guest-marketplace-header__logo"
          src="/images/rsg-marketplace-logo.png"
          alt={GUEST_MARKETPLACE_CONSTANTS.GUEST_MARKETPLACE_PAGE_TITLE}
        />
        <span className="guest-marketplace-header__separator" aria-hidden />
      </div>
      <div className="guest-marketplace-header__tagline">
        <span className="guest-marketplace-header__tagline-icon" aria-hidden>
          <InfoSVG variant="green" />
        </span>
        <div className="guest-marketplace-header__tagline-copy">
          <span className="guest-marketplace-header__tagline-title">{taglineTitle}</span>
          {taglineDescription && <span className="guest-marketplace-header__tagline-description">{taglineDescription}</span>}
        </div>
      </div>
      <span className="guest-marketplace-header__separator" aria-hidden />
      <div className="guest-marketplace-header__actions">
        <Link
          to={ROUTE_PATHS.SIGN_IN}
          state={{ fromGuestMarketplace: true }}
          className="button green inverted small guest-marketplace-header__auth-btn">
          {BUTTON_CONSTANTS.SIGN_IN}
        </Link>
        <Link
          to={ROUTE_PATHS.SIGN_UP}
          state={{ fromGuestMarketplace: true }}
          className="button green medium guest-marketplace-header__auth-btn">
          {BUTTON_CONSTANTS.SIGN_UP}
        </Link>
        <Link
          to={ROUTE_PATHS.PUBLIC_MARKETPLACE_CART}
          className="guest-marketplace-header__cart button icon"
          aria-label="Open guest marketplace cart">
          <CartSVG />
          {cartItemCount > 0 && <span className="guest-marketplace-header__cart-badge" aria-hidden />}
        </Link>
      </div>
    </header>
  );
};

export default GuestMarketplaceHeader;
